import { useCallback, useState } from 'react';

import { useWorkersService, MediaFileUploadType } from '@restworld/data-services';

export const useMediaFileUpload = () => {
  const workerService = useWorkersService();
  const [loading, setLoading] = useState(false);
  const uploadFile = useCallback(
    async ({ file, type }: MediaFileUploadType) => {
      setLoading(true);
      try {
        const resp = await workerService.sendAsset({ file, type });
        setLoading(false);
        return resp.data;
      } catch (error) {
        console.error(`error uploading file`, error);
        setLoading(false);
        throw error;
      }
    },
    [workerService]
  );
  const deleteUploadedFile = async (payload: { url: string }) => {
    setLoading(true);
    try {
      const resp = await workerService.deleteAsset({ ...payload });
      setLoading(false);
      return resp.data;
    } catch (error) {
      console.error(`error deleting file`, error);
      setLoading(false);
      return null;
    }
  };
  return { uploadFile, deleteUploadedFile, loading };
};
